module.exports = __webpack_public_path__ + "static/media/right-arrow.073e1c9d.svg";